import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["gender", "pronoun", "sterilization", "alteredSelect"]

  connect() {
    console.log("AgeNeuteredBreedController connected");
    this.syncView();
  }

  syncView() {
    const gender = this.genderTarget.value.toString().toLowerCase();
    const pronoun = { "male": "He", "female": "She" }[gender] || "they";
    const sterilization = { "male": "neutered", "female": "spayed" }[gender] || "sterilized";

    this.pronounTarget.innerText = pronoun;
    this.sterilizationTarget.innerText = sterilization;

    const alteredSelect = this.alteredSelectTarget;
    const alteredOptions = alteredSelect.querySelectorAll("option");

    // Loop over each option and hide those that don't match the selected gender.
    alteredOptions.forEach((option) => {
      const optionGender = option.getAttribute("data-gender")?.toLowerCase();
      if (optionGender === gender) {
        option.style.display = "block";
      } else {
        option.style.display = "none";
      }
    });

    // Check the currently selected value in the altered select.
    const currentValue = alteredSelect.value;
    const currentOption = alteredSelect.querySelector(`option[value="${currentValue}"]`);

    // If the current option is hidden or doesn't exist, reset the value.
    if (!currentOption || currentOption.style.display === "none") {
      // Try to find an option that matches the sterilized default.
      const defaultOption = Array.from(alteredOptions).find((option) => {
        return option.value.toLowerCase() === sterilization;
      });
      if (defaultOption) {
        alteredSelect.value = defaultOption.value;
      }
    }
  }
}
